/* eslint-disable unicorn/no-array-for-each,unicorn/no-array-method-this-argument,unicorn/no-array-callback-reference */
import angular from 'angular';

/**
 * @returns {any}
 */
const nrReplaceInterceptorFactory = /* @ngInject */ () => ({
	// optional method
	response: (/** @type {any} */ response) => {
		if (angular.isObject(response.data._NR_replace)) {
			angular.forEach(response.data._NR_replace, (kid, nr) => {
				//let id = Object.keys(response.data.returns)[0];
				angular.forEach(response.data.returns, (element, id) => {
					angular.forEach(response.data.returns[id].result, (nrResult, _kid) => {
						if (_kid === kid) {
							delete response.data.returns[id].result[kid];
							response.data.returns[id].result[nr] = nrResult;
						}
					});
				});
			});
		}
		return response;
	},
});

angular.module('app')
	.factory('nrReplaceInterceptor', nrReplaceInterceptorFactory);
